import { composeFetch } from '@library/http'
import { addPath, composeRequest, goustoHeaders, setHost } from '@library/http/requests'
import { getDomain, getEnvironment, isDev } from '@library/environment/isomorphic'

import type { WelcomeExperienceResponse } from './interfaces'

const LOCAL_API_HOST = 'https://staging-api.gousto.info'

function getActivateApiHost() {
  if (isDev()) {
    return LOCAL_API_HOST
  }

  return `https://${getEnvironment()}-api.${getDomain()}`
}

const parseWelcomeExperience = async (response: Response): Promise<WelcomeExperienceResponse> => {
  if (!response.ok) {
    const responseMsg = await response.text()
    throw new Error(`service responded with ${response.status}: ${responseMsg}`)
  }

  return (await response.json()) as WelcomeExperienceResponse
}

export const getWelcomeExperience = composeFetch(
  composeRequest(
    setHost(getActivateApiHost),
    addPath('activate/onboarding/welcome/v1'),
    goustoHeaders,
  ),
  parseWelcomeExperience,
)

export const getWelcomeHeader = getWelcomeExperience
